import { Box, Divider, Flex, Link, SimpleGrid, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { CalendarIcon, Search2Icon } from '@chakra-ui/icons';

export const ExamPeriod = () => (
  <Flex w="100%" alignItems="center" justifyContent="center">
    <Flex
      w="100%"
      maxW="90vh" // if you want same visual cap as App
      direction="column"
      rounded={5}
      alignItems="center"
    >
      <Divider borderWidth={'3px'} borderRadius={'60px'} my="10px" bg="teal" />

      {/* Motion div with the good luck exam wishes */}
      <motion.div
        initial={{
          y: -150,
          x: 0,
          opacity: 0,
          scale: 0.3,
          rotateX: -180,
          rotateZ: 80,
        }}
        animate={{
          y: 0,
          x: 0,
          opacity: 1,
          scale: 1,
          rotateX: 0,
          rotateZ: 0,
        }}
        transition={{
          ease: [0.42, 0, 0, 1.08],
          duration: 1.2,
          delay: 0.5,
          type: 'spring',
        }}
      >
        <Text
          fontWeight={'bold'}
          fontSize={'large'}
          textAlign="right"
          width="100%"
        >
          {/* <u>Best of luck</u> with your exams this semester!{' '}
          <span style={{ fontWeight: 'normal', opacity: 0.5 }}>-Savvy</span> */}
          People often say that motivation doesn&apos;t last. <br />
          Well, neither does bathing. That&apos;s why we recommend it daily.
          <br />
          <span style={{ fontWeight: 'normal', opacity: 0.7 }}>
            -Zig Ziglar
          </span>
        </Text>
      </motion.div>

      {/* Exam Resources */}
      <SimpleGrid columns={[1, 1, 2]} spacing={10} width="100%" mt={5}>
        <motion.div
          initial={{
            y: -150,
            x: 0,
            opacity: 0,
            rotateZ: 180,
          }}
          animate={{
            y: 0,
            x: 0,
            opacity: 1,
            rotateZ: 0,
          }}
          transition={{
            duration: 0.8,
            delay: 0.4,
            type: 'spring',
          }}
        >
          <Link href={'https://examtimetables.ncl.ac.uk/'} target="_blank">
            <Box
              width="100%"
              height="80px"
              bg="linear-gradient(69.9deg, rgba(181, 84, 0, 1) 3.2%, rgb(214, 9, 40) 97.6%);"
              mt={0}
              borderRadius={25}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text>
                Your Exam Timetable <CalendarIcon mb={1} />
              </Text>
            </Box>
          </Link>
        </motion.div>

        <motion.div
          initial={{
            y: -150,
            x: 0,
            opacity: 0,
            rotateZ: -180,
          }}
          animate={{
            y: 0,
            x: 0,
            opacity: 1,
            rotateZ: 0,
          }}
          transition={{
            duration: 0.8,
            delay: 0.4,
            type: 'spring',
          }}
        >
          <Link href={'https://roomfinder.ncl.ac.uk/'} target="_blank">
            <Box
              width="100%"
              height="80px"
              bg="linear-gradient(69.9deg, rgba(119, 0, 99, 1) 3.2%, rgba(0, 151, 131, 1) 97.6%);"
              mt={[-4, -4, 0]}
              borderRadius={25}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text>
                Room Finder <Search2Icon mb={1} />
              </Text>
            </Box>
          </Link>
        </motion.div>
      </SimpleGrid>

      <Divider
        borderWidth={'3px'}
        borderRadius={'60px'}
        mt="20px"
        mb="5px"
        bg="teal"
      />
    </Flex>
  </Flex>
);
